import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import { ErrorLayout } from "@/components/error-layout";
import { LoadingLayout } from "@/components/loading-layout";
import { Button } from "@/components/ui/button";

/** The same pending/error treatment at every data boundary. */
export function QueryState({
  error,
  loadingMessage,
  onRetry,
}: {
  error?: Error | string | null;
  loadingMessage?: string;
  onRetry?: () => void;
}) {
  if (!error) return <LoadingLayout message={loadingMessage} />;
  return (
    <ErrorLayout
      header="Could not load this content"
      message={typeof error === "string" ? error : error.message}
      actions={
        onRetry && (
          <Button
            label="Retry"
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SMALL}
            onClick={onRetry}
          />
        )
      }
    />
  );
}
